export default __webpack_public_path__ + "pgnv-assets/f4da4c751e640fa08c848a3afe123355.png";